import React from "react";
import ActionButtons from "../../components/ActionButtons";
import { storageRongve, firestoreRongve } from "../../firebase";
import Axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaGift, FaUsers, FaBell, FaImage, FaHeading, FaCalendarAlt } from 'react-icons/fa';
import { styles } from './Styles';

const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

const otherCategories = ["Trener", "Forelder", "Spiller"];

export default function RongvePostMemberBenefits(props) {
  const [users, setUsers] = React.useState([]);
  const [alerts, setAlerts] = React.useState([]);
  const [push, setPush] = React.useState(false);
  const [selectedClubs, setSelectedClubs] = React.useState([]);
  const [clubs, setClubs] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [content, setContent] = React.useState("");
  const [batchLogs, setBatchLogs] = React.useState([]);
  const [sendingComplete, setSendingComplete] = React.useState(false);

  const getClubInfo = async () => {
    const logoRef = storageRongve.ref("clubLogos/");
    const newClubs = [];
    const res = await logoRef.listAll();
    await Promise.all(
      res.items.map(async (itemRef) => {
        newClubs.push(itemRef.name);
      })
    );

    newClubs.forEach((club, index) => {
      newClubs[index] = club.slice(0, -4);
    });

    setClubs(newClubs);
  };

  React.useEffect(() => {
    getClubInfo();
    getUsers();
  }, []);

  const isSelected = (item) => selectedClubs.includes(item) || (selectAll && item !== "Alle");
  const handleClubSelection = (club) => {
    if (selectedClubs.includes(club)) {
      setSelectedClubs(selectedClubs.filter((id) => id !== club));
    } else {
      setSelectedClubs((prev) => [...prev, club]);
    }
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedClubs([...clubs, ...otherCategories]);
      setSelectAll(true);
      setSelectedClubs((prev) => [...prev, "Alle"]);
      const checkboxes = document.querySelectorAll(
        'input[type="checkbox"]:not(#selectAll)'
      );
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } else {
      setSelectedClubs([]);
      setSelectAll(false);
    }
  };

  const postMemberBenefits = async () => {
    const image = document.getElementById("image").files[0];
    var imageBase64 = null;
    if (image) {
      imageBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => resolve(reader.result.slice(22));
        reader.onerror = (error) => reject(error);
      });
    }
    const title = document.getElementById("title").value;
    const date = document.getElementById("date").value;

    if (title && content && date) {
      firestoreRongve
        .collection("memberBenefits")
        .add({
          image: imageBase64,
          title: title,
          content: content,
          date: date,
          clubs: selectedClubs,
        })
        .then(() => props.setActive(""))
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
      handlePushNotification();
    }
  };

  const getUsers = async () => {
    const usersRef = firestoreRongve.collection("users");
    const snapshot = await usersRef.get();
    const userList = [];
    snapshot.forEach((doc) => {
      const userData = doc.data();
      userList.push({ id: doc.id, ...userData });
    });
    setUsers(userList);
  };

  const handlePushNotification = async () => {
    let pushTokens = [];
    const title = document.getElementById("title").value;

    // Reset logs and completion state when starting new send
    setBatchLogs([]);
    setSendingComplete(false);

    users.forEach((user) => {
      if (user.expoPushToken && user.expoPushToken.length > 0) {
        const userClubIds = (user.clubIds || []).map((id) =>
          id.replace(".png", "")
        );

        const isForEveryone = selectedClubs.includes("Alle");

        const relevantClubs = userClubIds.filter((club) =>
          selectedClubs.includes(club)
        );
        const hasClub = relevantClubs.length > 0;
        const isOnlyRolesNews =
          selectedClubs.includes(user.userType) &&
          !selectedClubs.some((c) => clubs.includes(c));
        const isGeneralRoleNews =
          selectedClubs.includes(user.userType) && selectedClubs.length === 1;
        const isRoleAndClubNews =
          hasClub && selectedClubs.includes(user.userType);
        const isGeneralClubNews = hasClub && selectedClubs.length === 1;
        const isTrainerNews =
          user.trainer &&
          selectedClubs.includes("Trener") &&
          (hasClub || selectedClubs.length === 1);

        if (
          isForEveryone ||
          isGeneralRoleNews ||
          isRoleAndClubNews ||
          isGeneralClubNews ||
          isTrainerNews ||
          isOnlyRolesNews
        ) {
          pushTokens.push(user.expoPushToken);
        }
      }
    });

    pushTokens = Array.from(new Set(pushTokens));
    
    if (push) {
      setAlerts([...alerts, { title }]);

      const tokenChunks = chunkArray(pushTokens, 100);
      let successCount = 0;
      
      try {
        for (let i = 0; i < tokenChunks.length; i++) {
          const chunk = tokenChunks[i];
          const tokensBatch = JSON.stringify(chunk);
          
          try {
            await Axios.post(
              `https://webnow-adminpanel.ew.r.appspot.com/send?pushTokens=${tokensBatch}&title=Ny medlemsfordel&body=${title}&useFcmV1=true`
            );
            successCount++;
            setBatchLogs(prev => [...prev, {
              batchNumber: i + 1,
              success: true,
              message: `Batch ${i + 1}: Sendt til ${chunk.length} tokens`
            }]);
          } catch (error) {
            setBatchLogs(prev => [...prev, {
              batchNumber: i + 1,
              success: false,
              message: `Feil i batch ${i + 1}: ${error.message}`
            }]);
          }
        }
      } finally {
        setSendingComplete(true);
        setBatchLogs(prev => [...prev, {
          batchNumber: tokenChunks.length + 1,
          summary: true,
          message: `Alle ${tokenChunks.length} batches forsøkt sendt. ${successCount} av ${tokenChunks.length} vellykkede.`
        }]);
      }
    }
  };

  const BatchLogs = () => {
    const logStyle = {
      marginTop: '20px',
      padding: '10px',
      backgroundColor: '#000',
      borderRadius: '5px'
    };

    const logLineStyle = {
      margin: '5px 0',
      fontFamily: 'monospace'
    };

    return batchLogs.length > 0 ? (
      <div style={logStyle}>
        {batchLogs.map((log, index) => (
          <div key={index} style={logLineStyle}>
            {log.summary ? (
              <strong>{log.message}</strong>
            ) : (
              <>
                {log.success ? '✅' : '❌'} {log.message}
              </>
            )}
          </div>
        ))}
      </div>
    ) : null;
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        <FaGift style={styles.headerIcon} /> Legg ut medlemsfordel
      </h2>
      <form>
        <div style={styles.inputGroup}>
          <FaImage style={styles.inputIcon} />
          <input 
            type="file" 
            style={styles.fileInput} 
            id="image" 
          />
        </div>
        
        <div style={styles.inputGroup}>
          <FaHeading style={styles.inputIcon} />
          <input
            type="text"
            style={styles.input}
            id="title"
            placeholder="Tittel"
          />
        </div>
        
        <div style={styles.quillContainer}>
          <ReactQuill
            value={content}
            onChange={setContent}
            placeholder="Innhold"
            id="content"
            modules={styles.quillModules}
          />
        </div>
        
        <div style={styles.inputGroup}>
          <FaCalendarAlt style={styles.inputIcon} />
          <input 
            type="date" 
            style={styles.input} 
            id="date" 
          />
        </div>
        
        <div style={styles.categorySection}>
          <h3 style={styles.categoryHeader}>
            <FaUsers style={styles.categoryIcon} /> Velg målgrupper
          </h3>
          <div style={styles.selectionContainer}>
            <div 
              style={{
                ...styles.selectionBox,
                ...(selectAll ? styles.selectedBox : {})
              }}
              onClick={handleSelectAll}
            >
              Alle
            </div>
          </div>
          
          <h4 style={styles.subCategoryHeader}>Velg kategorier:</h4>
          <div style={styles.selectionContainer}>
            {otherCategories.map((category) => (
              <div 
                key={category}
                style={{
                  ...styles.selectionBox,
                  ...(isSelected(category) ? styles.selectedBox : {})
                }}
                onClick={() => handleClubSelection(category)}
              >
                {category}
              </div>
            ))}
          </div>
          
          <h4 style={styles.subCategoryHeader}>Velg klubber:</h4>
          <div style={styles.selectionContainer}>
            {clubs.map((club) => (
              <div 
                key={club}
                style={{
                  ...styles.selectionBox,
                  ...(isSelected(club) ? styles.selectedBox : {})
                }}
                onClick={() => handleClubSelection(club)}
              >
                {club}
              </div>
            ))}
          </div>
        </div>
        
        <div style={styles.notificationContainer}>
          <FaBell style={styles.notificationIcon} />
          <div 
            style={{
              ...styles.selectionBox,
              ...(push ? styles.selectedBox : {})
            }}
            onClick={() => setPush(!push)}
          >
            Send ut notifikasjoner
          </div>
        </div>
        
        <ActionButtons
          setActive={props.setActive}
          onClick={postMemberBenefits}
        />
      </form>
      
      {sendingComplete && (
        <div style={styles.alert}>
          Alle notifikasjoner er sendt!
        </div>
      )}
      
      <BatchLogs />
    </div>
  );
}